import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { DayFilterTypes } from 'app/modules/common/enums/day-filter-enums';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';

@Component({
    selector: 'app-days-filter',
    templateUrl: './days-filter.component.html',
    styleUrls: ['./days-filter.component.scss'],
    standalone: false
})
export class DaysFilterComponent implements OnInit {

  @Input() DayFilterType: DayFilterTypes;
  @Input() DaysFrom: UntypedFormControl;
  @Input() DaysTo: UntypedFormControl;

  @Output() DaysFromChanged = new EventEmitter();
  @Output() DaysToChanged = new EventEmitter();
  IsDropdownVisible = true;

  DayFilterLabel = '';

  dayOptions$ = [
    { text: 'Ninguno', start: 0, end: 0 },
    { text: 'Menos de 4', start: 0, end: 4 },
    { text: 'Entre 4 y 15', start: 4, end: 15 },
    { text: 'Entre 16 y 30', start: 16, end: 30 },
    { text: 'Entre 31 y 90', start: 31, end: 90 },
    { text: 'Entre 91 y 180', start: 91, end: 180 },
    { text: 'Entre 181 y 300', start: 181, end: 300 },
    { text: 'Más de 300', start: 300, end: 545 }
  ];

  constructor(public selectionService: SelectionGenericService) { }

  ngOnInit(): void {
    this.DaysFrom.setValidators([Validators.min(0), Validators.max(545)]);
    this.DaysTo.setValidators([Validators.min(0), Validators.max(545)]);

    this.setLabelAndDefaultValue();
  }

  setLabelAndDefaultValue(): void {
    let from = null;
    let to = null;
    switch (this.DayFilterType) {
      case DayFilterTypes.Leave:
        this.DayFilterLabel = 'Días de baja';
        from = this.selectionService.leaveSelectionModal.LeaveDaysFrom === undefined ? null : this.selectionService.leaveSelectionModal.LeaveDaysFrom;
        to = this.selectionService.leaveSelectionModal.LeaveDaysTo === undefined ? null : this.selectionService.leaveSelectionModal.LeaveDaysTo;
        this.DaysFrom.setValue(from);
        this.DaysTo.setValue(to);
        break;

      case DayFilterTypes.LeaveEndOfPeriod:
        this.DayFilterLabel = 'Días a fin de periodo';
        from = this.selectionService.leaveSelectionModal.LeaveEndOfPeriodDaysFrom === undefined ? null : this.selectionService.leaveSelectionModal.LeaveEndOfPeriodDaysFrom;
        to = this.selectionService.leaveSelectionModal.LeaveEndOfPeriodDaysTo === undefined ? null : this.selectionService.leaveSelectionModal.LeaveEndOfPeriodDaysTo;
        this.DaysFrom.setValue(from);
        this.DaysTo.setValue(to);
        break;

      case DayFilterTypes.LeaveInPeriod:
        this.DayFilterLabel = 'Días en periodo';
        from = this.selectionService.leaveSelectionModal.LeaveInPeriodDaysFrom === undefined ? null : this.selectionService.leaveSelectionModal.LeaveInPeriodDaysFrom;
        to = this.selectionService.leaveSelectionModal.LeaveInPeriodDaysTo === undefined ? null : this.selectionService.leaveSelectionModal.LeaveInPeriodDaysTo;
        this.DaysFrom.setValue(from);
        this.DaysTo.setValue(to);
        break;

      case DayFilterTypes.Labor:
        this.DayFilterLabel = 'Días laborables de baja';
        from = this.selectionService.leaveSelectionModal.LaborDaysFrom === undefined ? null : this.selectionService.leaveSelectionModal.LaborDaysFrom;
        to = this.selectionService.leaveSelectionModal.LaborDaysTo === undefined ? null : this.selectionService.leaveSelectionModal.LaborDaysTo;
        this.DaysFrom.setValue(from);
        this.DaysTo.setValue(to);
        break;

      case DayFilterTypes.LaborEndOfPeriod:
        this.DayFilterLabel = 'Días laborables a fin periodo';
        from = this.selectionService.leaveSelectionModal.LaborEndOfPeriodDaysFrom === undefined ? null : this.selectionService.leaveSelectionModal.LaborEndOfPeriodDaysFrom;
        to = this.selectionService.leaveSelectionModal.LaborEndOfPeriodDaysTo === undefined ? null : this.selectionService.leaveSelectionModal.LaborEndOfPeriodDaysTo;
        this.DaysFrom.setValue(from);
        this.DaysTo.setValue(to);
        break;

      case DayFilterTypes.LaborInPeriod:
        this.DayFilterLabel = 'Días laborables en periodo';
        from = this.selectionService.leaveSelectionModal.LaborInPeriodDaysFrom === undefined ? null : this.selectionService.leaveSelectionModal.LaborInPeriodDaysFrom;
        to = this.selectionService.leaveSelectionModal.LaborInPeriodDaysTo === undefined ? null : this.selectionService.leaveSelectionModal.LaborInPeriodDaysTo;
        this.DaysFrom.setValue(from);
        this.DaysTo.setValue(to);
        break;

      case DayFilterTypes.LeaveCommunicationGap:
        this.IsDropdownVisible = false;
        this.DayFilterLabel = 'Gap de bajas';
        from = this.selectionService.leaveSelectionModal.LeaveCommunicationGapDaysFrom === undefined ? null : 
          this.selectionService.leaveSelectionModal.LeaveCommunicationGapDaysFrom;
        to = this.selectionService.leaveSelectionModal.LeaveCommunicationGapDaysTo === undefined ? null : 
          this.selectionService.leaveSelectionModal.LeaveCommunicationGapDaysTo;
        this.DaysFrom.setValue(from);
        this.DaysTo.setValue(to);
        break;

      default:
        break;
    }
  }

  setSelectedOption(option: any): void {
    const fromValue = option.start === 0 ? null : option.start;
    const toValue = option.end === 0 ? null : option.end;

    this.DaysFrom.setValue(fromValue);
    this.DaysTo.setValue(toValue);

    this.DaysFromChanged.emit(fromValue);
    this.DaysToChanged.emit(toValue);
  }

  triggerDayChange(inputType: string): void {
    if (inputType === 'From') {
      if (this.DaysFrom.valid) {
        const fromValue = this.DaysFrom.value === '' ? null : this.DaysFrom.value;
        this.DaysFromChanged.emit(fromValue);
      } else {
        this.DaysFromChanged.emit(null);
      }
      

    } else if (inputType === 'To') {
      if (this.DaysTo.valid) {
        const toValue = this.DaysTo.value === '' ? null : this.DaysTo.value;
        this.DaysToChanged.emit(toValue);
      } else {
        this.DaysToChanged.emit(null);
      }
      
    }
  }

}
